import { css } from 'styled-components';
import { pxToRem } from '@anwb/style-utilities';
export const getGenericSpacing = (type) => (directions) => css(({ theme }) => css `
			${directions.map((direction) => `${type}-${direction}: ${pxToRem(theme.spacing['200'])};`)}

			@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
				${directions.map((direction) => `${type}-${direction}: ${pxToRem(theme.spacing['300'])};`)}
			}
		`);
//# sourceMappingURL=get-generic-spacing.js.map